<template>
  <div class="passes">
    <img
      v-for="index in 8"
      :key="index"
      :src="require(`@/assets/images/pass-${index % 2 === 0 ? 'normal' : 'alt'}.gif`)"
      alt=""
      draggable="false"
      :class="`pass pass-${index}`"
    />
  </div>
</template>

<script>
export default {
  name: 'Passes'
}
</script>

<style lang="scss" scoped>
.passes {
  position: relative;
}

.pass {
  position: absolute;
  width: 100px;
  height: 100px;

  &-1,
  &-2,
  &-3 {
    top: 0;
  }

  &-1,
  &-6 {
    left: 0;
  }

  &-2,
  &-7 {
    left: 50%;
    transform: translateX(-50%);
  }

  &-3,
  &-8 {
    right: 0;
  }

  &-4,
  &-5 {
    top: 100px;
  }

  &-4 {
    left: 25%;
    transform: translateX(-25%);
  }

  &-5 {
    left: 75%;
    transform: translateX(-75%);
  }

  &-6,
  &-7,
  &-8 {
    top: 200px;
  }
}
</style>
